import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
);

interface MetricGraphProps {
  data: number[];
  color: 'purple' | 'blue' | 'green';
}

const colorMap = {
  purple: 'rgb(147, 51, 234)',
  blue: 'rgb(59, 130, 246)',
  green: 'rgb(34, 197, 94)'
};

export function MetricGraph({ data, color }: MetricGraphProps) {
  const chartData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        data,
        borderColor: colorMap[color],
        backgroundColor: `${colorMap[color]}20`,
        tension: 0.4,
        fill: true,
        pointRadius: 0,
        borderWidth: 2
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        display: false
      },
      y: {
        display: false
      }
    }
  };

  return (
    <div className="h-16">
      <Line data={chartData} options={options} />
    </div>
  );
}